import { Component, OnInit } from '@angular/core';
import { PageLayoutComponent } from '@app/components/shared/page-layout/page-layout.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MapComponent } from '@app/components/shared/map/map.component';
import { Pin } from '@app/components/shared/map/model/pin';


@Component({
  selector: 'faxe-track-map',
  imports: [
    PageLayoutComponent,
    ReactiveFormsModule,
    MapComponent
  ],
  templateUrl: './track-map.component.html',
  styleUrl: './track-map.component.scss'
})
export class TrackMapComponent implements OnInit  {
  pins: Pin[];

  ngOnInit(): void {
    this.mockPins();
  }

  mockPins() {
    this.pins = [
      {
        name: 'Pin 1',
        description: 'Description 1',
        latitude: 58.32038919999999,
        longitude: 13.7206603
      },
      {
        name: 'Pin 2',
        description: 'Description 2',
        latitude: 58.32039919999999,
        longitude: 13.7206604
      }
    ];
  }


}
